import { APINodeClient } from './apiNodeCore';

const api = new APINodeClient();


export const insertStaffHotelApi = async (response: any) => {
  return api.create('/staff/add-new-staff',response);
};





export const getAllStaffHotelApi = async () => {
  return api.create('/staff/get-all-staff');
};


export const deleteStaffHotelApi = async (response: any) => {
  return api.create('/staff/delete-staff',response);
};